import Vue from 'vue';

export default Vue.directive('google-signin-button', {
  bind: function (el, binding, vnode) {
    const clientId = binding.value;
    let googleSignInAPI = document.createElement('script');
    googleSignInAPI.setAttribute('src', 'https://accounts.google.com/gsi/client');
    document.head.appendChild(googleSignInAPI);

    googleSignInAPI.onload = initGoogleButton;

    function initGoogleButton() {
      window.google.accounts.id.initialize({
        client_id: clientId,
        callback: (response) => {
          vnode.context.onGoogleAuthSuccess(response);
        },
      });
      window.google.accounts.id.renderButton(document.getElementById('signin_button'), {
        theme: 'outline',
        size: 'large',
      });
    }
  },
});
